import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Constants } from '~/app/core/configs/constants';
@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  transactionId;
  status;
  transactionDetail: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  transactionHasUpdated: Subject<boolean> = new Subject<boolean>();
  formHasChange: Subject<boolean> = new Subject<boolean>();
  confirmChangeTab: Subject<boolean> = new Subject<boolean>();
  invalidForm: Subject<boolean> = new Subject<boolean>();
  isMultiModal_outTrans: Subject<boolean> = new Subject<boolean>();
  validate_inTrans: Subject<any> = new Subject<any>();

  constructor(
  ) { }

  updateValidateInTrans(inTransMode) {
      let res = {
        multi: inTransMode == Constants.TransportMode.MULTI,
        is_null: inTransMode ? false: true
      };
      this.validate_inTrans.next(res);
  }

}
